export default __webpack_public_path__ + "static/media/star-icon-(6).d8c3ff4b.svg";